/// <reference types="./i18n" />

import { I18nProviderWrapper } from "./I18nProviderWrapper";

export * from "./I18nMarkup";
export * from "./I18nSpan";
export * from "./I18nContextWrapper";
export * from "./I18nContext";
export * from "./I18nProvider";
export * from "./hooks/useI18nContext";
export * from "./hooks/useI18nCurrency";
export * from "./utils/getLang";
export * from "./utils/getRootLang";
export * from "./LanguageSelect";
export * from "./types";
export * from "./constants";
export * from "./I18nProviderSSR";
export * from "./init";

// Re-export Trans from react-i18next to ensure consistent version usage
// Components should import Trans from @hopper-b2b/i18n instead of react-i18next
export { Trans } from "react-i18next";

export * from "../locales/en";
export * from "../locales/es";
export * from "../locales/pt";
export * from "../locales/fr";

export default I18nProviderWrapper;

export const DEFAULT_LANG = "en-US";
